<template>
  <div class="fill-height" :style="`padding: 24px 24px 24px 274px`">
    <template v-if="auth">
      <side-menu-component :role="role" :user="user"/>
    </template>
    <transition mode="out-in"
                enter-active-class="transition-ease-in-out"
                leave-active-class="transition-ease-in-out">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {

    }
  },
  computed: {
    auth () {
      return !!this.$store.getters.GET_USER
    },
    role () {
      return this.$store.getters.GET_ROLE
    },
    user () {
      return this.$store.getters.GET_USER
    },
    width () {
      return this.$store.getters.GET_WIDTH
    }
  }
}
</script>

<style scoped>

</style>
